import deepEqual from 'deep-equal';

const events: string[] = [
    'beforeEdit',
    'cancel',
    'cellClose',
    'change',
    'columnHide',
    'columnLock',
    'columnMenuInit',
    'columnMenuOpen',
    'columnReorder',
    'columnResize',
    'columnShow',
    'columnUnlock',
    'dataBinding',
    'dataBound',
    'detailCollapse',
    'detailExpand',
    'detailInit',
    'edit',
    'excelExport',
    'filter',
    'group',
    'groupCollapse',
    'groupExpand',
    'page',
    'pdfExport',
    'filterMenuInit',
    'filterMenuOpen',
    'remove',
    'save',
    'saveChanges',
    'sort',
    'navigate'
];

const configuration: string[] = [
    'allowCopy',
    'autoBind',
    'columnResizeHandleWidth',
    'columns',
    'columnMenu',
    'editable',
    'excel',
    'filterable',
    'groupable',
    'height',
    'messages',
    'mobile',
    'navigatable',
    'noRecords',
    'pageable',
    'pdf',
    'persistSelection',
    'reorderable',
    'resizable',
    'scrollable',
    'selectable',
    'sortable',
    'toolbar'
];

const reconcileEvents = (oldEvents, newEvents, widget) => {
    Object.keys(oldEvents).map(key => {
        widget.unbind(key, oldEvents[key]);
    });
    Object.keys(newEvents).map(key => {
        widget.bind(key, newEvents[key]);
    });
};

const reconcileConfiguration = (oldConfiguration, newConfiguration, widget) => {
    if (!deepEqual(oldConfiguration, newConfiguration, { strict: true })) {
        widget.setOptions(newConfiguration);
    }
};

export { configuration, events, reconcileEvents, reconcileConfiguration };



// WEBPACK FOOTER //
// ./packages/kendo-grid-react-wrapper/src/grid/util.ts